import script from "./personalInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./personalInformation.vue?vue&type=script&setup=true&lang=ts"

import "./personalInformation.vue?vue&type=style&index=0&id=4d57b52b&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d57b52b"]])

export default __exports__